import {Component} from '@angular/core';
import {Block}     from "../../block";

@Component({
    selector   : 'app-usps',
    templateUrl: './usps.component.html',
})
export class UspsComponent extends Block {

}
